import { render, staticRenderFns } from "./Email.vue?vue&type=template&id=5abfe26d&"
import script from "./Email.vue?vue&type=script&lang=js&"
export * from "./Email.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5abfe26d')) {
      api.createRecord('5abfe26d', component.options)
    } else {
      api.reload('5abfe26d', component.options)
    }
    module.hot.accept("./Email.vue?vue&type=template&id=5abfe26d&", function () {
      api.rerender('5abfe26d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/inputs/Email.vue"
export default component.exports